/**
 * Utility function to get profile image URL from PRID
 * @param prid - User's PRID
 * @returns Profile image URL or empty string
 */
export function getProfileImageUrl(prid: string | null | undefined): string {
  return prid ? `https://adhoc.rd.astrazeneca.net/api/thumbs/${prid}?appid=befair` : '';
}
